// extracted by mini-css-extract-plugin
export default {"theme-segment":"lsf-theme-segment","theme-segment__item":"lsf-theme-segment__item","theme-segment__item_active":"lsf-theme-segment__item_active"};